<template>
  <v-container fluid id="visit_zlecone_zabiegi">
    <v-row justify="end">
      <v-col cols="5" class="text-right">
        <v-btn color="primary" @click="showZlec=true" v-if="$can('do','POKO_ZabiegiZlecanie')">Zleć zabieg</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :items="zleconeZabiegi"
            :headers="headers">
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwaZabiegu}}</td>
              <td>{{props.item.podtyp}}</td>
              <td>{{dateTimeFormat(props.item.start)}}</td>
              <td>{{dateTimeFormat(props.item.koniec)}}</td>
              <td>
                <v-icon small class="mr-2"  v-if="$can('do','POKO_ZabiegiZlecanie')" @click="removeZabieg(props.item.id)" title="Usuń zabieg">fa-trash-alt</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ZlecZabieg :zabiegi="zabiegi" v-if="showZlec" @close="showZlec = false" :visible="showZlec" :data_wizyty="data_wizyty" :vid="vid" @selected="selectedZabieg"></ZlecZabieg>
  </v-container>
</template>

<script>
import dayjs from "dayjs";
import ZlecZabieg from "@/components/visits/ZlecZabieg";
import {visitService, zabiegiService} from "@/services";
import {mapActions} from "vuex";
import swal from "sweetalert";
import {roleService} from "@/components/admin/roles/Roles";

export default {
  name: "TherapistZleconeZabiegi",
  components: {ZlecZabieg},
  props: ["vid", "data_wizyty"],
  data(){
    return {
      showZlec: false,
      zleconeZabiegi: [],
      zabiegi: [],
      headers: [
        {text: 'Nazwa zabiegu', sortable: false, align: 'left', value: 'nazwaZabiegu'},
        {text: 'Podtyp zabiegu', sortable: false, align: 'left', value: 'podtyp'},
        {text: 'Początek', sortable: false, align: 'left', value: 'start'},
        {text: 'Koniec', sortable: false, align: 'left', value: 'koniec'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],

    }
  },
  mounted() {
    zabiegiService.getZabiegiList().then(result=> {
      this.zabiegi = result.data.result
    }).catch(() => {
      this.error('Błąd pobierania listy zabiegów')
    })
    this.refreshZleconeZabiegi()
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    removeZabieg(id)
    {
      swal({
        title: "Czy na pewno?",
        text:
            "Czy na pewno chcesz usunąć ten zlecony zabieg?",
        icon: "warning",
        buttons: ["Nie", "Tak"],
        dangerMode: true
      }).then(confirmed => {
        if (confirmed) {
          visitService.deleteZleconyZabieg(id).then(() => {
            this.refreshZleconeZabiegi()
          }).catch(e => {
            if (
                e.response != null &&
                e.response.data != null &&
                e.response.data.error != null
            ) {
              this.error(e.response.data.error.message)
            } else {
              this.error('Błąd usuwania zabiegu')
            }
          })
        }
      });

    },
    refreshZleconeZabiegi()
    {
      visitService.getZleconeZabiegi(this.vid).then(result=> {
        this.zleconeZabiegi = result.data.result
      }).catch(()=>{
        this.error('Błąd pobierania zleconych zabiegów')
      })
    },
    selectedZabieg(values)
    {
      visitService.insertZleconyZabieg({
        zabiegId: values.zabieg.id,
        sourceVisitId: this.vid,
        startTime: values.termin.data_start,
        endTime: values.termin.data_koniec,
        podtypZabieguId: values.podtyp_zabiegu != null ? values.podtyp_zabiegu.id : 0
      }).then(()=> {
        this.refreshZleconeZabiegi()
      }).catch((e)=> {

        if (
            e.response != null &&
            e.response.data != null &&
            e.response.data.error != null
        ) {
          this.showError(false,e.response.data.error.message)
        } else {
          this.showError(false,'Błąd zlecania zabiegu')
        }

      })
      this.showZlec = false
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
    dateTimeFormat(val)
    {
      if(val)
      {
        return dayjs(val).format('DD-MM-YYYY HH:mm')
      }
      return ''
    },
  }
}
</script>

<style scoped>

</style>